export const BREADCRUMBS_TRANSLATE = {
    breadcrumbs: {
        new: "Adicionar",
        update: "Editar",
        visualization: "Visualizar",
    }
};
